import React, { useState } from "react";
import BaseModal from "components/BaseModal";
import { useSession } from "hooks/useSession";

export default function RefundTransactionModal({ show, onClose, mode, userData }) {
  const [errors, setErrors] = useState({});
  const [step, setStep] = useState(1); // 1 = Enter RefID, 2 = Enter OTP
  const [refidValue, setRefidValue] = useState("");
  const { userid } = useSession();
  const [stateresp, setstateresp] = useState('');

  const showToast = (message, type = "primary") => {
    const alertDiv = document.createElement("div");
    alertDiv.className = `alert alert-${type} alert-dismissible position-fixed top-0 end-0 m-3 shadow`;
    alertDiv.setAttribute("role", "alert");
    alertDiv.style.zIndex = 2000;
    alertDiv.innerHTML = `
      <div class="d-flex justify-content-between align-items-center">
        <p class="mb-0 flex-grow-1">${message}</p>
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>`;
    document.body.appendChild(alertDiv);
    setTimeout(() => alertDiv.remove(), 3000);
  };

  const validateForm = (fields) => {
    let newErrors = {};
    fields.forEach((field) => {
      const value = document.getElementById(field)?.value.trim();
      if (!value) newErrors[field] = `${field.toUpperCase()} is required.`;
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSendOTP = async () => {
    if (!validateForm(["refid"])) {
      showToast("Please enter the Refund Transaction ID.", "danger");
      return;
    }

    const refid = document.getElementById("refid").value.trim();
    setRefidValue(refid);

    const formData = new FormData();
    formData.append("refid", refid);
    formData.append("userid", userid);

    try {
      const response = await fetch("https://pro.mokshiq.in/paeps_refund_transection", {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: formData,
      });
      const result = await response.json();

      if (result.status) {
        if (result.data.response_code === 1) {
          showToast(result.data.message || "Refund OTP Sent successfully!", "success");
          setstateresp(result.data.data.stateresp);
          setStep(2); // move to OTP step

        } else {
          showToast(result.data.message || "Refund OTP not sent!", "danger");
        }
      } else {
        showToast(result.data || "Refund request failed!", "danger");
      }
    } catch {
      showToast("Something went wrong!", "danger");
    }
  };

  const handleVerifyOTP = async () => {
    if (!validateForm(["otp"])) {
      showToast("Please enter the OTP.", "danger");
      return;
    }

    const otp = document.getElementById("otp").value.trim();

    const formData = new FormData();
    formData.append("refid", refidValue);
    formData.append("userid", userid);
    formData.append("otp", otp);
    formData.append("stateresp", stateresp);

    try {
      const response = await fetch("https://pro.mokshiq.in/paeps_refund_transection_otp", {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: formData,
      });
      const result = await response.json();

      if (result.status) {
        if (result.data.response_code === 1) {
          showToast(result.data.message || "Refund Verified Successfully!", "success");
          onClose();
        } else {
          showToast(result.data.message || "Invalid OTP!", "danger");
        }
      } else {
        showToast(result.data || "Verification failed!", "danger");
      }
    } catch {
      showToast("Something went wrong!", "danger");
    }
  };

  return (
    <BaseModal
      show={show}
      onClose={onClose}
      title="Refund Transaction"
      footerButtons={[
        { label: "Cancel", className: "btn-secondary", dismiss: true },
        step === 1
          ? { label: "Send OTP", className: "btn-primary", onClick: handleSendOTP }
          : { label: "Verify OTP", className: "btn-success", onClick: handleVerifyOTP },
      ]}
    >
      <div className="card-body">
        <form className="row g-3 app-form rounded-control">
          {step === 1 && (
            <div className="col-md-12">
              <label className="form-label">Refund Transaction ID</label>
              <input
                id="refid"
                className={`form-control ${errors.refid ? "is-invalid" : ""}`}
                defaultValue={userData?.refid || ""}
                placeholder="Enter Refund Transaction ID"
              />
              {errors.refid && <div className="text-danger">{errors.refid}</div>}
            </div>
          )}

          {step === 2 && (
            <div className="col-md-12">
              <label className="form-label">Enter OTP</label>
              <input
                id="otp"
                className={`form-control ${errors.otp ? "is-invalid" : ""}`}
                placeholder="Enter OTP received on your registered device"
              />
              {errors.otp && <div className="text-danger">{errors.otp}</div>}
            </div>
          )}
        </form>
      </div>
    </BaseModal>
  );
}
